export const classes = {
  root: {
    boxShadow: 'none',
  },
};
